import { UrlSegment, UrlMatchResult } from '@angular/router';

export class RegexUrlMatcher {
  getRegexUrlMatcherRegexUrlMatcher(
    url: UrlSegment[],
    regex: RegExp,
    capturedParameterNames: string[]
  ): UrlMatchResult | null {
    if (url.length === 0) {
      return null;
    }

    capturedParameterNames.splice(0, 0, 'fullPath');

    const fullPath = url.reduce((buffer, current) => buffer + '/' + current.path, '');
    let result: RegExpExecArray | null;

    if ((result = regex.exec(fullPath))) {
      const posParams: { [p: string]: UrlSegment } = {};
      for (let index = 0; index < result.length; index++) {
        posParams[capturedParameterNames[index]] = new UrlSegment(result[index], {});
      }
      return { consumed: url, posParams: posParams };
    }

    return null;
  }
}
